import React, { useContext, useState } from "react";
import { Context } from "../../../../config/store";
import MandateModal from "./MandateModal";

const Action = (props) => {
    const { state } = useContext(Context);
    const checkHasPermission = (checkPermission) => {
        if (state.is_super_admin === 1) return true;
        const permission = state.permission.find(
            (permission) => permission === checkPermission
        );

        if (permission) return true;
        else return false;
    };

    return (
        <div className={`row no-gutters ${props.className}`}>
            {checkHasPermission('add-mandate') && [6].includes(props?.leadInfo?.cl_lead_lender_status) && props?.row?.mandate_status !== 1 && <EditFile {...props} />}
        </div>
    );
};

const EditFile = ({ row, reloadTable, leadInfo }) => {
    const { state } = useContext(Context);
    const [loading, setloading] = useState(null)
    const [modalState, setModalState] = useState(false);
    const [editMode, setEditMode] = useState(false)

    const toggleModal = () => {
        setModalState(!modalState);
        setEditMode(!editMode)
    };

    return (
        <>
            {/* <button className="btn  ml-2" onClick={toggleModal}>
                {loading ? <div className="loader" /> : <i class="fa fa-edit text-orange" title="Edit"></i>}
            </button> */}
            <button className="btn" onClick={toggleModal} style={{'margin-left': 40}}>
                {loading ? <div className="loader" /> : <i class="fa fa-paper-plane text-orange" title="Submit"></i>}
            </button>
            {modalState && (
                <MandateModal
                    userType={state.userType}
                    state={modalState}
                    toggleModal={toggleModal}
                    rowData={row}
                    editMode={editMode}
                    leadId={row?.cl_lead_id}
                    lenderId={row?.cl_lender_id}
                    reloadTable={reloadTable}
                    lafNumber={leadInfo?.cl_lead?.laf_id}
                />
            )}
        </>
    );
};

export default Action;
